import { Coins } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function BalanceNode({ id, data, selected }) {
  const summary = data.token ? `Check ${data.token} balance` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallet}
      icon={Coins}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
